import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';
import { AppButton } from '@/shared/components';

interface SearchButtonProps {
  readonly isLoading: boolean;
  readonly onClick: () => void;
  readonly disabled?: boolean;
}

export function SearchButton({
  isLoading,
  onClick,
  disabled = false,
}: Readonly<SearchButtonProps>) {
  const { t } = useTranslation();

  return (
    <AppButton
      fullWidth
      variant="primary"
      size="small"
      onClick={onClick}
      disabled={disabled}
      loading={isLoading}
      startIcon={<SearchIcon />}
    >
      {isLoading ? t('search.searching') : t('search.searchButton')}
    </AppButton>
  );
}
